
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"23.129","height":"19.031"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.47 19.031L0 10.561l4.373-4.372 4.1 4.1L18.756 0l4.373 4.375zm0 0","fill":"#5fac36"}})])
          )
        }
      }
    